(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pedido-rapido-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  var raiz = document.getElementById('pedido-rapido');
  if (!raiz || raiz.dataset.montado) return;
  raiz.dataset.montado = '1';

  var $ = function (s) { return raiz.querySelector(s); };
  var ta = $('#prTexto'), panel = $('[data-pr-panel]'), cuerpo = $('[data-pr-cuerpo]');
  var resumen = $('[data-pr-resumen]'), noRes = $('[data-pr-nores]'), aviso = $('[data-pr-aviso]');
  var presu = $('[data-pr-presu]');
  var btnAnadir = $('[data-pr-anadir]');

  var INDICE = null, CRUDO = null;

  /* El índice pesa 362 KB comprimidos, así que NO se descarga con la página:
     se pide la primera vez que alguien pulsa «Revisar». Quien solo pasa por
     aquí no lo paga. */
  function cargaIndice() {
    if (INDICE) return Promise.resolve(INDICE);
    return fetch(raiz.dataset.indice, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        /* Formato nuevo: { v: referencias, p: plazos, d: diccionario }. Se acepta
           también el viejo (un mapa plano) por si queda un asset cacheado. */
        CRUDO = j;
        INDICE = j && j.v ? j.v : j;
        return INDICE;
      });
  }


  /* ────────────────────────────────────────────────────────────────────────
     «QUISO DECIR…»
     ────────────────────────────────────────────────────────────────────────
     Un digito mal en una referencia de 7 cifras deja al cliente sin saber que
     ha fallado. Comparar contra 45.000 claves por cada fallo seria lentisimo,
     asi que se agrupan por sus DOS primeros caracteres y solo se comparan las
     de longitud parecida: cada busqueda mira unos cientos.

     Se acepta UNA sola diferencia: un caracter cambiado, sobrante o que falta.
     Con dos, la sugerencia deja de ser fiable y es peor que no sugerir. */
  var CUBOS = null;
  function cubos(idx) {
    if (CUBOS) return CUBOS;
    CUBOS = {};
    for (var k in idx) { var c = k.slice(0, 2); (CUBOS[c] || (CUBOS[c] = [])).push(k); }
    return CUBOS;
  }
  function pareceA(a, b) {
    if (Math.abs(a.length - b.length) > 1 || a === b) return false;
    if (a.length === b.length) {
      var d = 0;
      for (var i = 0; i < a.length; i++) if (a[i] !== b[i] && ++d > 1) return false;
      return d === 1;
    }
    var lg = a.length > b.length ? a : b, ct = a.length > b.length ? b : a, i2 = 0, j = 0, saltos = 0;
    while (i2 < lg.length && j < ct.length) {
      if (lg[i2] === ct[j]) { i2++; j++; } else { if (++saltos > 1) return false; i2++; }
    }
    return true;
  }
  function sugiere(ref, idx) {
    var lista = cubos(idx)[ref.slice(0, 2)];
    if (!lista) return null;
    for (var i = 0; i < lista.length; i++) if (pareceA(ref, lista[i])) return lista[i];
    return null;
  }

  var norm = function (s) { return String(s || '').trim().toUpperCase().replace(/\s+/g, ' '); };

  /* Una línea → { ref, cantidad } o null.

     El ORDEN es lo que hace que esto funcione: primero se prueba la línea
     ENTERA contra el índice, porque hay referencias con espacios y números
     dentro (`FLUKE-718EX 30`). Solo si no existe se busca una cantidad al
     final. Al revés, ese «30» se comería como cantidad. */
  function parseaLinea(linea, idx) {
    /* Copiar de Excel o de un PDF mete ESPACIOS DUROS (NBSP). Se escribe
       escapado a proposito: un NBSP literal aqui es invisible y el dia que
       alguien reformatee el fichero desaparece sin que nadie lo note. */
    var t = linea.replace(/\u00a0/g, ' ').trim();
    if (!t) return null;

    if (idx[norm(t)]) return { ref: norm(t), cant: 1 };

    var m = /^(.*?)[\s;,|\t]+[xX]?\s*(\d{1,5})\s*(?:uds?\.?|unidades?)?$/.exec(t);
    if (m) {
      var ref = norm(m[1]);
      var cant = parseInt(m[2], 10);
      if (ref && cant > 0) return { ref: ref, cant: cant };
    }
    return { ref: norm(t), cant: 1 };
  }

  function pinta(lineas, idx) {
    var vistos = {}, orden = [], desconocidas = [], consulta = [];
    lineas.forEach(function (l) {
      var p = parseaLinea(l, idx);
      if (!p) return;
      var v = idx[p.ref];
      /* Cadena en vez de numero = producto BAJO CONSULTA. Existe y esta
         publicado, pero no se vende online: no puede entrar al carrito y
         merece un mensaje propio, no el de «no esta en el catalogo». */
      if (typeof v === 'string') {
        if (!consulta.some(function (c) { return c.ref === p.ref; }))
          consulta.push({ ref: p.ref, handle: v.slice(1) });
        return;
      }
      if (!v) { if (desconocidas.indexOf(p.ref) === -1) desconocidas.push(p.ref); return; }
      /* La misma referencia repetida SUMA en vez de sustituir: pegar dos veces
         una línea suele significar dos pedidos distintos, no un error. */
      if (vistos[p.ref]) { vistos[p.ref] += p.cant; }
      else { vistos[p.ref] = p.cant; orden.push(p.ref); }
    });

    cuerpo.innerHTML = orden.map(function (r) {
      return '<tr data-ref="' + r + '">'
        + '<td class="pr__ref">' + r + '</td>'
        + '<td class="pr__num"><input type="number" min="1" step="1" value="' + vistos[r] + '" aria-label="Cantidad de ' + r + '"></td>'
        + '<td class="pr__num"><button type="button" class="pr__quitar" aria-label="Quitar ' + r + '">&times;</button></td>'
        + '</tr>';
    }).join('');

    var unidades = orden.reduce(function (a, r) { return a + vistos[r]; }, 0);
    resumen.innerHTML = '<b>' + orden.length + '</b> referencia' + (orden.length === 1 ? '' : 's')
      + ' reconocida' + (orden.length === 1 ? '' : 's') + ' · <b>' + unidades + '</b> unidad'
      + (unidades === 1 ? '' : 'es');

    if (consulta.length) {
      presu.hidden = false;
      presu.innerHTML = '<b>' + consulta.length + ' se vende'
        + (consulta.length === 1 ? '' : 'n') + ' bajo presupuesto</b>'
        + 'Estos productos se configuran segun el proyecto, asi que no se anaden al carrito. '
        + 'Pide precio y plazo desde su ficha: '
        + consulta.map(function (c) {
            return '<a href="/products/' + c.handle + '"><code>' + c.ref + '</code></a>';
          }).join(', ');
    } else { presu.hidden = true; }

    if (desconocidas.length) {
      noRes.hidden = false;
      noRes.innerHTML = '<b>' + desconocidas.length + ' sin reconocer</b>'
        + desconocidas.map(function (d) {
            var s2 = sugiere(d, idx);
            return '<code>' + d + '</code>'
              + (s2 ? ' <span class="pr__sug">— ¿quisiste decir <b>' + s2 + '</b>?</span>' : '');
          }).join('<br>');
    } else { noRes.hidden = true; }

    panel.hidden = false;
    btnAnadir.disabled = orden.length === 0;
    aviso.hidden = true;
  }

  $('[data-pr-revisar]').addEventListener('click', function () {
    var lineas = ta.value.split(/\r?\n/);
    if (!lineas.join('').trim()) { ta.focus(); return; }
    this.disabled = true; this.textContent = 'Cargando…';
    var btn = this;
    cargaIndice().then(function (idx) {
      pinta(lineas, idx);
    }).catch(function (e) {
      aviso.hidden = false;
      aviso.className = 'pr__aviso pr__aviso--mal';
      aviso.textContent = 'No se ha podido cargar el catálogo de referencias (' + e.message + '). Recarga la página.';
      panel.hidden = false;
    }).then(function () { btn.disabled = false; btn.textContent = 'Revisar lista'; });
  });

  $('[data-pr-limpiar]').addEventListener('click', function () {
    ta.value = ''; panel.hidden = true; ta.focus();
  });

  cuerpo.addEventListener('click', function (e) {
    var b = e.target.closest('.pr__quitar'); if (!b) return;
    var fila = b.closest('tr'); fila.parentNode.removeChild(fila);
    btnAnadir.disabled = cuerpo.children.length === 0;
  });

  btnAnadir.addEventListener('click', function () {
    var items = [];
    Array.prototype.forEach.call(cuerpo.children, function (tr) {
      var n = parseInt(tr.querySelector('input').value, 10);
      if (n > 0) items.push({ id: INDICE[tr.dataset.ref], quantity: n, ref: tr.dataset.ref });
    });
    if (!items.length) return;

    /* ──────────────────────────────────────────────────────────────────────
       SEMBRAR EL PLAZO DE ENTREGA
       ──────────────────────────────────────────────────────────────────────
       El desglose del carrito («2 ud. en stock · 1 ud. en 15D») y la columna del
       Excel salen de `localStorage`, que normalmente rellena la FICHA al
       visitarla. Quien pega una lista aquí no pasa por ninguna ficha, así que
       sus líneas se quedaban sin plazo — y este atajo existe justo para no
       entrar en las fichas.

       Se escribe con la MISMA clave y la MISMA forma que usa
       `custom-availability.liquid`: si cambia allí, hay que cambiarlo aquí. */
    try {
      if (CRUDO && CRUDO.p) {
        var k = 'fluitronic_plazo_v1';
        var mapa = JSON.parse(localStorage.getItem(k) || '{}');
        items.forEach(function (i) {
          var d = CRUDO.p[i.id];
          if (!d) return;
          mapa[i.id] = { stock: d[0], fast: '1-2D', plazo: (CRUDO.d && CRUDO.d[d[1]]) || '' };
        });
        localStorage.setItem(k, JSON.stringify(mapa));
      }
    } catch (e) { /* sin plazo se sigue pudiendo comprar: no se corta el flujo */ }

    btnAnadir.disabled = true; btnAnadir.textContent = 'Añadiendo…';
    var raizUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* Se manda TODO en una sola llamada. Si Shopify rechaza el lote —basta con
       que una línea no tenga stock— no añade nada, así que en ese caso se
       reintenta una a una para poder decir CUÁL falló en vez de un «no se pudo»
       genérico. */
    fetch(raizUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items.map(function (i) { return { id: i.id, quantity: i.quantity }; }) })
    }).then(function (r) {
      if (r.ok) return r.json().then(function () { return { ok: items.length, fallos: [] }; });
      return unaAUna(raizUrl, items);
    }).then(function (res) {
      aviso.hidden = false;
      if (res.fallos.length) {
        aviso.className = 'pr__aviso pr__aviso--mal';
        var conMotivo = res.fallos.filter(function (f) { return f.motivo; });
        aviso.innerHTML = '<b>' + res.ok + '</b> añadidas al carrito.'
          + '<br>No se han podido añadir:'
          + '<ul class="pr__fallos">'
          + res.fallos.map(function (f) {
              return '<li><code>' + esc(f.ref) + '</code>'
                + (f.motivo ? ' — ' + esc(f.motivo) : '') + '</li>';
            }).join('')
          + '</ul>'
          + (conMotivo.length < res.fallos.length
              ? 'Las que no dan motivo suelen ser productos sin stock o que no se venden online.'
              : '');
      } else {
        aviso.className = 'pr__aviso pr__aviso--ok';
        aviso.innerHTML = '<b>' + res.ok + '</b> referencias añadidas al carrito. '
          + '<a href="' + raizUrl + 'cart">Ir al carrito</a>';
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function (e) {
      aviso.hidden = false;
      aviso.className = 'pr__aviso pr__aviso--mal';
      aviso.textContent = 'No se ha podido añadir al carrito: ' + e.message;
    }).then(function () {
      btnAnadir.disabled = false; btnAnadir.textContent = 'Añadir al carrito';
    });
  });

  /* ⚠ Se GUARDA el motivo que da Shopify, no se adivina.
     Antes solo se apuntaba la referencia y el aviso decía «suelen ser productos sin stock o
     que no se venden online». Eso es una conjetura, y con las cantidades por múltiplos es
     falsa la mayoría de las veces: el motivo real venía en `description` del 422, redactado
     y accionable —«has pedido 10 y solo se sirve de 100 en 100. Pon 100 y podrás seguir»—.
     Un cliente que pega su lista de compra con una cantidad no múltiplo leía «no hay stock»
     y se iba. Hay 3.166 artículos con múltiplo de venta. */
  /* El motivo lo redacta nuestra propia función de validación, pero llega por la red y
     acaba en `innerHTML`: se escapa igual. Un `<` sin escapar en un nombre de producto
     partiría el aviso sin dar ningún error. */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function unaAUna(raizUrl, items) {
    var ok = 0, fallos = [];
    return items.reduce(function (cadena, it) {
      return cadena.then(function () {
        return fetch(raizUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: it.id, quantity: it.quantity }] })
        }).then(function (r) {
          if (r.ok) { ok++; return; }
          /* El cuerpo puede no ser JSON —bajo límite de peticiones la tienda devuelve
             HTML—, así que si no se puede leer se queda sin motivo y ya está. */
          return r.json().then(function (d) {
            fallos.push({ ref: it.ref, motivo: (d && (d.description || d.message)) || '' });
          }).catch(function () { fallos.push({ ref: it.ref, motivo: '' }); });
        }).catch(function () { fallos.push({ ref: it.ref, motivo: '' }); });
      });
    }, Promise.resolve()).then(function () { return { ok: ok, fallos: fallos }; });
  }

  /* ---- apertura y cierre ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pedido-rapido]');
    if (t) { e.preventDefault(); raiz.showModal(); ta.focus(); return; }
    if (e.target.closest('[data-pr-cerrar]')) { raiz.close(); return; }
    /* Clic en el fondo: el <dialog> recibe el evento cuando se pulsa fuera de
       la caja, así que basta con comprobar que el objetivo es el propio
       diálogo y no algo de dentro. */
    if (e.target === raiz) raiz.close();
  });

  /* `/pages/pedido-rapido` y cualquier enlace con #pedido-rapido lo abren solo:
     así el enlace se puede mandar por correo y sigue funcionando. */
  if (location.pathname.indexOf('/pages/pedido-rapido') === 0 || location.hash === '#pedido-rapido') {
    raiz.showModal();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
